import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axios from "lib/axios";

export type useResourceListProps = {
  resourceName: string;
  path?: string;
  params?: object;
} & Omit<UseQueryOptions<any[]>, "queryKey">;

export const useResourceList = ({
  resourceName,
  path,
  params = {},
  ...props
}: useResourceListProps): UseQueryResult<any[]> => {
  return useQuery({
    queryFn: async () => {
      const { data } = await axios.get(path ?? `${resourceName}`, { params });
      return data[resourceName];
    },
    ...props,
    queryKey: [resourceName, params],
  });
};
